import styles from "./StatCard.module.css";

interface StatCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
}

export function StatCard({ label, value, subtitle }: StatCardProps) {
  return (
    <div className={styles.card}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {typeof value === "number" ? value.toLocaleString() : value}
      </span>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
    </div>
  );
}
